function QuantitySelect({ loading, Skeleton, setQuantity, quantity, selectedSize }) {
  return (

    <div className={`quantity-selector Qunatity-m001 ${quantity === 0 ? "d-none" : ""}`} style={{ display: "flex", alignItems: "center", gap: "6px" }}>
      {loading ? (
        <>
          <Skeleton height={18} width={100} style={{ marginBottom: 10 }} />
          <div className="qty-control">
            <Skeleton height={35} width={100} borderRadius={8} />
          </div>
        </>
      ) : (
        <>
          <p style={{ marginBottom: "0" }}> Quanitity </p>
          <div className="qty-control">
            <button onClick={() => setQuantity((q) => Math.max(1, q - 1))}>−</button>
            <span className="order_track_count">{quantity}</span>
            <button onClick={() => setQuantity((q) => q + 1)} disabled={quantity >= selectedSize?.stock}>+</button>
          </div>
        </>
      )}
    </div>
  )
}
export default QuantitySelect;